export const notFoundContent = {
    en: {
      title: "404 - Page not found",
      text: "The page you’re looking for doesn’t exist or has been moved.",
      home: "Back to homepage",
      hint: "Check the URL for typos or use the menu above to navigate.",
    },
    sl: {
        title: "404 - Stran ni najdena",
        text: "Žal stran, ki jo iščete, ne obstaja ali je bila premaknjena.",
        home: "Nazaj na domačo stran",
        hint: "Preverite URL za kakršne koli napake ali uporabite meni za navigacijo.",
    },

} as const;